// extracted by mini-css-extract-plugin
module.exports = {"Component":"Button_Component__7sNW-","btn-green":"Button_btn-green__2664f"};